// extracted by mini-css-extract-plugin
export var colorSquare = "_pi-0";
export var danger = "_pi-5";
export var lightPink = "_pi-8";
export var neutralBlue = "_pi-7";
export var neutralYellow = "_pi-6";
export var normal = "_pi-1";
export var primary = "_pi-2";
export var primaryLight = "_pi-3";
export var solidBlack = "_pi-g";
export var solidGreen = "_pi-b";
export var solidLightBlue = "_pi-d";
export var solidNavy = "_pi-c";
export var solidOrange = "_pi-f";
export var solidPink = "_pi-e";
export var solidRed = "_pi-9";
export var solidYellow = "_pi-a";
export var success = "_pi-4";